export default __webpack_public_path__ + "86a9719e5a184597958c50831e5b4223.svg";